export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opakovat operaci"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Historie operací"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seznam účtů"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neznámá chyba"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seznam tokenů"])}
}